import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router'

import { MatDialogRef, MatDialog } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MyServiceService } from '../../my-service.service';
import { Chart } from 'chart.js';

import { EditSensorDialogComponent } from '../edit-sensor-dialog/edit-sensor-dialog.component';
import * as moment from 'moment'

@Component({
  selector: 'app-sensor-info-dialog',
  templateUrl: './sensor-info-dialog.component.html',
  styleUrls: ['./sensor-info-dialog.component.scss']
})
export class SensorInfoDialogComponent implements OnInit {

  constructor(private myService: MyServiceService,
    public dialogRef: MatDialogRef<SensorInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private router: Router) { }

  private http_data;

  public sensor_id;
  public status;
  public bat_level;
  public slot_name;
  public latit;
  public longit;

  private occupancyTime = new Array(0, 0, 0, 0, 0, 0, 0)
  private parkingEvents = new Array(0, 0, 0, 0, 0, 0, 0)
  private historic_data;
  public raw_data;

  public showChart = false;
  public showTable = false;

  ngOnInit() {
    this.myService.getSpecificSensor(this.data.id).subscribe(res => {
      this.http_data = res[0]

      this.sensor_id = this.http_data.id;
      this.status = this.http_data.status;
      this.bat_level = this.http_data.bat_lev;
      this.slot_name = this.http_data.slot;
      this.latit = this.http_data.latit;
      this.longit = this.http_data.longit;

      var status_img = document.getElementById("imageid") as HTMLImageElement;
      if (this.status == 'False') {
        status_img.src = "../assets/img/green_circle.png";
      }
      else {
        status_img.src = "../assets/img/red_circle.png";
      }
    })


    this.ctx = document.getElementById('canvas') as HTMLCanvasElement
    this.myLineChart = new Chart(this.ctx.getContext('2d'), this.config)
  }


  public config = {
    type: 'line',
    legend: true,
    data: {
      labels: [],
      datasets: [{
        label: '',
        data: [],
        fill: false,
        borderColor: "#55BAE7",
        backgroundColor: "#55BAE7",
        pointBackgroundColor: "#55BAE7",
        pointBorderColor: "#55BAE7",
        pointHoverBackgroundColor: "#55BAE7",
        pointHoverBorderColor: "#55BAE7"
      }]
    },
    options: {
      scaleShowVerticalLine: false,
      responsive: true,
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Days'
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            callback: function (value) { if (value % 1 === 0) { return value; } }
          },
          display: true,
          scaleLabel: {
            display: true,
            labelString: ''
          }
        }]
      }
    }
  }
  private ctx;
  private myLineChart;





  getParkingDuration() {
    for (var i = 0; i < this.occupancyTime.length; i++) {
      this.occupancyTime[i] = 0;
    }

    this.myService.getSpecificSensorHistoryWeek(this.data.id).subscribe(res => {
      this.historic_data = res

      var day = new Date().getDay()
      var chart_labels = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
      this.rotate(chart_labels, day)

      for (var i = 0; i < this.historic_data.length; i++) {
        var someDate = new Date(this.historic_data[i].date)

        if (new Date(this.historic_data[i].date).getDate() == new Date().getDate()) {
          this.occupancyTime[6] += this.historic_data[i].duration;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 1) {
          this.occupancyTime[5] += this.historic_data[i].duration;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 2) {
          this.occupancyTime[4] += this.historic_data[i].duration;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 3) {
          this.occupancyTime[3] += this.historic_data[i].duration;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 4) {
          this.occupancyTime[2] += this.historic_data[i].duration;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 5) {
          this.occupancyTime[1] += this.historic_data[i].duration;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 6) {
          this.occupancyTime[0] += this.historic_data[i].duration;
        }
      }

      for (var i = 0; i < this.occupancyTime.length; i++) {
        this.occupancyTime[i] = this.occupancyTime[i] / 60
      }

      this.myLineChart.data.labels = chart_labels
      this.myLineChart.data.datasets[0].data = this.occupancyTime
      this.myLineChart.data.datasets[0].label = 'Occupancy'
      this.myLineChart.options.scales.yAxes[0].scaleLabel.labelString = 'Minutes'
      this.myLineChart.update()
    })

    this.showChart = true;
    this.showTable = false;
  }



  getParkingEvents() {
    for (var i = 0; i < this.parkingEvents.length; i++) {
      this.parkingEvents[i] = 0;
    }

    this.myService.getSpecificSensorHistoryWeek(this.data.id).subscribe(res => {
      this.historic_data = res

      var day = new Date().getDay()
      var chart_labels = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
      this.rotate(chart_labels, day)

      for (var i = 0; i < this.historic_data.length; i++) {
        var someDate = new Date(this.historic_data[i].date)

        if (new Date(this.historic_data[i].date).getDate() == new Date().getDate()) {
          this.parkingEvents[6]++;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 1) {
          this.parkingEvents[5]++;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 2) {
          this.parkingEvents[4]++;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 3) {
          this.parkingEvents[3]++;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 4) {
          this.parkingEvents[2]++;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 5) {
          this.parkingEvents[1]++;
        }
        else if (new Date(this.historic_data[i].date).getDate() == new Date().getDate() - 6) {
          this.parkingEvents[0]++;
        }
      }

      this.myLineChart.data.labels = chart_labels
      this.myLineChart.data.datasets[0].data = this.parkingEvents
      this.myLineChart.data.datasets[0].label = 'Parking Events'
      this.myLineChart.options.scales.yAxes[0].scaleLabel.labelString = 'Events'
      this.myLineChart.update()
    })

    this.showChart = true;
    this.showTable = false;
  }



  getRawData() {
    this.myService.getSpecificSensorHistory(this.data.id).subscribe(res => {
      this.raw_data = res;

      for (var i = 0; i < this.raw_data.length; i++) {
        var dateString = new Date(this.raw_data[i]['date']).toUTCString()
        var trimmed = dateString.replace('GMT', '')
        this.raw_data[i]['date'] = trimmed

        if (this.raw_data[i].duration == 0) {
          this.raw_data[i]['departure'] = '-'
        }
        else {

          var arr = new Date(dateString).getTime() / 1000
          var dep = (arr - 3 * 60 * 60 + this.raw_data[i].duration) * 1000
          var departureTime = new Date(new Date(dep))
          var unixTimestamp = Math.round(new Date(departureTime).getTime() / 1000);
          var milisec = unixTimestamp * 1000
          var depTime = moment(milisec).format('ddd, DD MMM YYYY, HH:mm:ss')

          this.raw_data[i]['departure'] = depTime
        }

      }

    })

    this.showChart = false;
    this.showTable = true;
  }

  rotate(array, times) {
    while (times--) {
      var temp = array.shift();
      array.push(temp)
    }
  }




  editSensor(sensor_id, slot_name, latit, longit) {
    const dialogRef = this.dialog.open(EditSensorDialogComponent, {
      width: '600px',
      data: { "id": sensor_id, "slot": slot_name, "lat": latit, "lng": longit }
    });

    this.router.events.subscribe(() => {
      dialogRef.close()
    })

    dialogRef.afterClosed().subscribe(res => {
      location.reload()
    })

  }

  deleteSensor(sensor_id) {
    this.myService.deleteSensor(sensor_id).subscribe(res => {
      this.dialogRef.close()
    })
    this.dialogRef.close()
  }


}
